class CartRecommend extends HTMLElement {
  connectedCallback() {
    this._fetchRecommed();
    document.addEventListener('cartrecommed-refresh', () => {
      this._fetchRecommed();
    });
  }
  async _fetchRecommed() {
    const productId = this.getAttribute('product-id');
    const sectionId = this.getAttribute('section-id');
    const response = await fetch(`/recommendations/products?product_id=${productId}&section_id=${sectionId}&limit=10`);
    const div = document.createElement("div");
    div.innerHTML = await response.text();
    const recommendations = div.querySelector('.mini-cart__recommendations');
    if(!recommendations) return;
    const mini_cart = this.querySelector('.mini-cart__recommendations');
    if(mini_cart) {
      mini_cart.innerHTML = recommendations.innerHTML;
      const swiper = mini_cart.querySelector('.swiper');
      if(swiper) {
        new Swiper(swiper, {
          observer: true,
          observeParents: true,
          spaceBetween: 24,
          slidesPerView: 1,
          navigation: {
            nextEl: ".mini-cart__recommendations .swiper-button-next",
            prevEl: ".mini-cart__recommendations .swiper-button-prev",
          },
        });
      }
    }
  }
}
if (!customElements.get('cart-recommend')) {
  customElements.define('cart-recommend', CartRecommend);
}
